import type { ReactElement } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { useAuthStore } from '@/store/auth.store';
import { Layout } from './components/Layout';

import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Categories from './pages/Categories';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Debts from './pages/Debts';
import CustomerDetail from './pages/CustomerDetail';
import Subscription from './pages/Subscription';
import Integrations from './pages/Integrations';
import Analytics from './pages/Analytics';

function ProtectedRoute({ children }: { children: ReactElement }) {
  const token = useAuthStore((s) => s.accessToken);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/products" element={<Products />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/subscription" element={<Subscription />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/debts" element={<Debts />} />
                <Route path="/customers/:establishmentId" element={<CustomerDetail />} />
                <Route path="/integrations" element={<Integrations />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
